class Dialog {
    constructor($el) {
        this.$el = $el;
        this.$dialog = $el.closest('[data-gallery="item"]').find('[data-gallery="dialog"]');
        this.$close = $el.closest('[data-gallery="item"]').find('[data-gallery="close"]');
        this.$book = $el.closest('[data-gallery="item"]').find('[data-gallery="book"]');
        this.body = $('body');
        this.html = $('html'); this.init();
    }

    init = () => {
        this.$el.on('click', (e) => {
            e.preventDefault();
            this.$dialog[0].showModal();
            this.html.addClass('no-scroll');
            requestAnimationFrame(() => {
                this.$dialog[0].scrollTop = 0;
            });
            const scrollX = window.scrollX;
            const scrollY = window.scrollY;
            Object.assign(this.$dialog[0].style, {
                position: 'absolute',
                left: `${scrollX}px`,
                top: `${scrollY}px`,
                margin: '0'
            });
        });
        this.$book.on('click', this.close);
        this.$close.on('click', () => {
            this.close();
        });
        this.$dialog.on('click', (e) => {
            if (e.target == this.$dialog[0]) {
                this.close();
            }
        });
    };
    close = () => {
        this.$dialog[0].close();
        this.html.removeClass('no-scroll');
    }
} export default Dialog;